import React, { StrictMode } from 'react';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';

import Context from './Context';

import Main from './Main';

export default function Index() {
  return (
    <StrictMode>
      <UsersContextProvider>
        <Context>
          <Main />
        </Context>
      </UsersContextProvider>
    </StrictMode>
  );
}
